export function mainHeadSlider() {

    const $container = $('.main-head_slider__js');
    if ($container.length > 0) {
        $container.on("init", function (slick) {
            $('.js-slideLink').attr('href', $('.slick-current div[data-link]').data('link'));
        });

        $container.slick({
            infinite: false,
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: true,
            dots: true,
            appendDots: $('.main-head__js')
        });

        $container.on("afterChange", function (slick, currentSlide) {
            $('.js-slideLink').attr('href', $('.slick-current div[data-link]').data('link'));
        });

    }
}